import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

/**
 * This file is used for any timezone related dayjs functions by leveraging the utc and timezone plugins
 *
 * @module dayjs-timezone
 */

dayjs.extend(utc);
dayjs.extend(timezone);

export default dayjs;
